import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <>
    <div className="container homeTop" >
        <br />
        <h1 style={{margin:'0px'}}>Hi,there...</h1>
    </div>
    <div className='container homeStyle' >
        <br />
        <div className='d-flex flex-wrap' >
        </div>
    </div>
    </>
  )
}

export default Home